import React from "react";
import HUDFrame from "./HUDFrame";

export default function HowItWorks({ title = "HOW IT WORKS", steps }) {
  return (
    <section className="relative py-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <h2 className="text-center text-2xl md:text-3xl font-display font-black tracking-[0.22em]">
          {title}
        </h2>
        <HUDFrame className="mt-8" padding="p-6 md:p-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-4">
            {steps.map((s, i) => (
              <div key={s.title} className="relative flex lg:flex-col items-start lg:items-center gap-4 lg:gap-3 text-center lg:text-center">
                <div className="shrink-0 w-14 h-14 rounded-full border border-[rgba(157,252,4,0.45)] grid place-items-center text-[color:var(--ss-green)]">
                  {s.icon}
                </div>
                <div className="lg:text-center text-left">
                  <div className="text-xs font-display tracking-[0.24em] text-[color:var(--ss-green)]">
                    {String(i + 1).padStart(1, "0")}. {s.title}
                  </div>
                  <div className="mt-2 text-[color:var(--ss-muted)] text-sm leading-relaxed max-w-[260px] mx-auto">
                    {s.desc}
                  </div>
                </div>
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute right-[-10px] top-7 text-[color:var(--ss-green-dim)]">
                    →
                  </div>
                )}
              </div>
            ))}
          </div>
        </HUDFrame>
      </div>
    </section>
  );
}
